import { Store } from "@bryntum/schedulerpro";
import { TAGS_KEYS } from "../../other/constants/TagsKeys.jsx";
import { STORE_KEYS } from "../../other/constants/StoreKeys.jsx";

const TagKeyStoreMap = {
  [STORE_KEYS.clientTagValuesStore]: "clientsStore",
  [STORE_KEYS.taskTagValuesStore]: "extraTaskStore",
  [STORE_KEYS.resourceTagValuesStore]: "resourceStore",
  [STORE_KEYS.contactTagValuesStore]: "contactsStore",
}

const onRemoveTagFromEntity = (store, records) => {
  const selectedIds = records.map((rs) => rs.id);
  if (selectedIds.length) {
    const recordTagSet = records[0].tagSet;
    store.forEach((storeModel) => {
      if (recordTagSet === TAGS_KEYS.category && selectedIds.includes(storeModel.categoryId)) storeModel._category = null;
      if (recordTagSet === TAGS_KEYS.status && selectedIds.includes(storeModel.statusId)) storeModel._status = null;
      if (recordTagSet === TAGS_KEYS.phase && selectedIds.includes(storeModel.phaseId)) storeModel._phase = null;
      if (recordTagSet === TAGS_KEYS.tag && Array.isArray(storeModel.tagsId)) {
        storeModel._tags = storeModel.tagsId.filter((tagId) => !selectedIds.includes(tagId));
      }
    }, null, {
      includeFilteredOutRecords: true,
      includeCollapsedGroupRecords: true
    });
  }
};

const onUpdateTagOnEntity = (store, record) => {
  store.forEach((ctv) => {
    if (ctv.categoryId === record.id) ctv._category = record;
    else if (ctv.statusId === record.id) ctv._status = record;
    else if (ctv.phaseId === record.id) ctv._phase = record;
    else if (Array.isArray(ctv.tagsId) && ctv.tagsId.includes(record.id)) ctv._tags = record;
  }, null, {
    includeFilteredOutRecords: true,
    includeCollapsedGroupRecords: true
  })
};

export class SwivuTagValuesStore extends Store {

  onUpdate({ record }) {
    if (this.project) onUpdateTagOnEntity(this.project[TagKeyStoreMap[this.storeId]], record);
  }

  onRemove({ records }) {
    if (this.project) onRemoveTagFromEntity(this.project[TagKeyStoreMap[this.storeId]], records);
  }
}
